import BaseUseCase from "../../base_use_case.js.jsx";

class InvestmentPaymentMethodUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/projects/investment_steps/payment_method`,
      data: this.wrapParams(params, "investment"),
    });
  }
}

const instance = new InvestmentPaymentMethodUseCase();
export default instance;